const initialState = {
  tadbirData: null,
  tadbirGroupId: null,
  tadbirCondition: false
}

const tadbirData = (state = initialState, action) => {
  switch (action.type) {
    case "TADBIR_DATA":
      return { ...state, tadbirData: action.val }
    case "SAVE_TADBIR_DATA":
      return { ...state, tadbirGroupId: action.val }
    case "SAVE_TADBIR_CONDITION":
      return { ...state, tadbirCondition: action.val }
    default:
      return state
  }
}
export default tadbirData
